/**
 * What the assistant remembers across a page reload, and the one place that
 * forgets it.
 *
 * Only whether the panel was open is kept: every open starts a fresh
 * conversation, and past ones are reached through the session history. The
 * store is cleared the moment the user is no longer signed in.
 */

const PANEL_STATE_KEY = 'lamma-assistant-panel';

export interface PersistedPanelState {
  isOpen: boolean;
}

const EMPTY_PANEL_STATE: PersistedPanelState = { isOpen: false };

export function readPanelState(): PersistedPanelState {
  try {
    const raw = sessionStorage.getItem(PANEL_STATE_KEY);
    if (!raw) return EMPTY_PANEL_STATE;
    const parsed = JSON.parse(raw) as Partial<PersistedPanelState>;
    return { isOpen: parsed.isOpen === true };
  } catch {
    return EMPTY_PANEL_STATE;
  }
}

export function writePanelState(state: PersistedPanelState): void {
  try {
    sessionStorage.setItem(PANEL_STATE_KEY, JSON.stringify(state));
  } catch {
    // A browser refusing storage must not take the panel down with it.
  }
}

/** Forget everything: called the moment the user is no longer signed in. */
export function clearAssistantStorage(): void {
  try {
    sessionStorage.removeItem(PANEL_STATE_KEY);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
}
